'use strict'

import $ from 'jquery'

export default class Blob{
  constructor(el) {
    this.$el = $(el)
    // Partial may not be needed, leaving for now in case we need to trigger anything custom for the blob animations
  } 
}
